import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';

// Import des différents modules internes
import { setupSplit } from './text-split.js';
import { initRevealers } from './revealers.js';
import { initPanels } from './panels.js';
import { initNumberCounters } from './counter.js';
import { initFullSvg } from "./fullwidth-svg.js";
import { initGraphSvg } from "./graph.js";
import { initProgressBar } from "./progress-bar.js";
import { initHeroPlyr } from '../components/plyr.js';

gsap.registerPlugin(ScrollTrigger);

function startLoader() {
	let loader = gsap.timeline({
		defaults: {
			duration: 0.5,
			delay: 0.5,
			ease: 'power1.inOut',
		},
		onComplete: () => {
			// document.body.classList.remove('no-scroll');

			const player = initHeroPlyr();
			if (player) {
				player.play().catch((err) => {
					console.warn('Autoplay bloqué ou erreur Plyr :', err);
				});
			}

			initPanels();
			initFullSvg(".fullimage__bg");
			initGraphSvg();
			initProgressBar();
			initNumberCounters();

			// ⚡ Recalcule final après disparition du loader
			// ScrollTrigger.refresh();

			// ⚡ Ajout du listener resize
			// window.addEventListener("resize", () => ScrollTrigger.refresh());
		},
	});

	loader
		.to(
			'.logo-i-1, .logo-i-2',
			{
				scale: 1,
				y: 0,
				x: 0,
			},
			'1'
		)
		.to(
			[
				'.logo-f',
				'.logo-a',
				'.logo-v',
				'.logo-e',
				'.logo-l',
				'.logo-e',
				'.logo-y',
				'.logo-t',
				'.logo-e',
				'.logo-c',
				'.logo-h',
				'.logo-copy-1',
				'.logo-copy-2',
			],
			{
				opacity: 1,
			},
			'-=0.5'
		)
		.to(
			'#logoload',
			{
				opacity: 0,
				autoAlpha: 0,
			},
			'-=0.5'
		)
		.to(
			'.loader__bg',
			{
				width: 0,
				duration: 0.75,
			},
			'-=0.5'
		)
		.to(
			'.loader',
			{
				autoAlpha: 0,
				pointerEvents: 'none',
			}
		)
		.call(() => {
			// ⚡ Initialisation des reveals et split quand le loader disparaît
			setupSplit();
			initRevealers();
		}, null, '-=1.66');
}
// Fin du loader, débloque le scroll et refresh ScrollTrigger

if (document.readyState === 'complete') {
	console.log('document.readyState:', document.readyState);
	startLoader();
} else {
	window.addEventListener('load', startLoader);
}
